import fetchServer from "../../../fetchServer";
import {
  isChangeAlreadyAccepted,
  isManualChangeProcessingStatus,
  isChangeManualReviewStatus,
} from "../../../../data/flight/order/getChangeAdminGuidance";

function extractErrorMessage(res) {
  return (
    res?.data?.data?.error ||
    res?.data?.error ||
    res?.error ||
    res?.data?.message ||
    res?.message ||
    null
  );
}

function extractPayload(res) {
  // Success: axios response → res.data.data
  // Error from fetchServer catch: body only → res.data or res itself
  if (res?.data?.data != null && typeof res.data.data === "object") {
    return res.data.data;
  }
  if (res?.data != null && typeof res.data === "object" && !res.status) {
    return res.data;
  }
  return res?.data?.data ?? res?.data ?? null;
}

function didAcceptSucceed(payload) {
  if (!payload || typeof payload !== "object") return true;
  // Accept moves ManualReviewRequired → ManualDateChangeProcessing / ManualNameChangeProcessing
  if (isManualChangeProcessingStatus(payload?.status)) return true;
  if (isChangeAlreadyAccepted(payload)) return true;
  // Backend may return a thin ack without status fields
  if (payload.status == null) return true;
  // Still on eligibility review = transition did not happen
  if (isChangeManualReviewStatus(payload.status)) return false;
  if (String(payload.status).toLowerCase() === "pending") return false;
  // Any other status means we left review
  return true;
}

export default async function approveChangeTicketRequest(id) {
  const changeId =
    typeof id === "object" && id ? id._id || id.id : id;

  let result = {
    return: 0,
    msg: "Failed approving request",
    data: [],
  };

  if (!changeId || typeof changeId !== "string") {
    result.msg = "Missing change request id";
    return result;
  }

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/changeBooking/approve/${changeId}`,
  })
    .then((res) => {
      if (!res || res.cancelled) return;

      const httpOk = res.status >= 200 && res.status < 300;
      const nestedError = extractErrorMessage(res);
      const payload = extractPayload(res);

      if (httpOk && nestedError && payload?.code) {
        result = {
          return: 0,
          msg: nestedError,
          data: payload,
          error: nestedError,
        };
        return;
      }

      if (httpOk) {
        if (!didAcceptSucceed(payload)) {
          result = {
            return: 0,
            msg:
              "Approve returned OK but status is still waiting for review. Backend did not move this to ManualDateChangeProcessing / ManualNameChangeProcessing.",
            data: payload,
            error: "status_not_transitioned",
          };
          return;
        }
        result = {
          return: 1,
          msg: res.data?.message || "Successful",
          data: payload,
        };
        return;
      }

      // fetchServer returns response body on HTTP error (no .status)
      result.msg =
        nestedError ||
        (typeof res?.msg === "string" ? res.msg : null) ||
        result.msg;
      if (payload) result.data = payload;
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result.msg = "Network Error!";
        result.error = "Please check your connection.";
      }
    });

  return result;
}
